import { render, staticRenderFns } from "./deliverGoodsSettingDialog.vue?vue&type=template&id=55e4cc37&scoped=true&"
import script from "./deliverGoodsSettingDialog.vue?vue&type=script&lang=js&"
export * from "./deliverGoodsSettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./deliverGoodsSettingDialog.vue?vue&type=style&index=0&id=55e4cc37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e4cc37",
  null
  
)

export default component.exports